import { dataTrackCut } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrackCut = /*#__PURE__*/createIcon(dataTrackCut)
export default IconTrackCut
